import * as React from 'react';

export interface ISupportsConfirmationBox {
    confirmProps?: IConfirmProps | null,
    setConfirmProps?: (confirmProps: IConfirmProps | null) => void
}

export interface IConfirmProps {
    message: React.ReactNode;
    options: string[];
    defaultOption?: string;
    setResult: (value: string) => void
}

export const ConfirmationBox = (props: IConfirmProps) => {
    const onClick = (e: React.MouseEvent<HTMLTableCellElement, MouseEvent>) => {
        e.stopPropagation();

        if (e.target === e.currentTarget && props.options.length === 1) {
            props.setResult(props.options[0]);
        }
    }

    return (
        <>
            {props.message &&
                <div className="confirm-container">
                    <div className="confirm-backdrop" onClick={onClick}>
                    </div>
                    <div className="confirm-box">
                        <div className="confirm-message">
                            {props?.message}
                        </div>
                        <div className="confirm-button-container">
                            {
                                props.options.map(opt => {
                                    return (
                                        <button
                                            key={opt}
                                            className={(opt === props.defaultOption ? "btn-primary " : "") + "pr-4 pl-4 mb-5 ml-3 mr-3 btn btn-secondary"}
                                            onClick={() => { if (props.setResult) props.setResult(opt); }}
                                        >{opt}</button>
                                    );
                                })
                            }
                        </div>
                    </div>
                </div>
            }
        </>
    );
};